import { render, staticRenderFns } from "./message-input-editor.vue?vue&type=template&id=084dcd1a&scoped=true"
import script from "./message-input-editor.vue?vue&type=script&lang=ts"
export * from "./message-input-editor.vue?vue&type=script&lang=ts"
import style0 from "./message-input-editor.vue?vue&type=style&index=0&id=084dcd1a&prod&scoped=true&lang=scss"
import style1 from "./message-input-editor.vue?vue&type=style&index=1&id=084dcd1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084dcd1a",
  null
  
)

export default component.exports